import styled from 'styled-components';
import tw from 'twin.macro';

export const AttachmentCountButton = styled.button`
  ${tw`text-gray-700 body-xs-bold p-1 rounded-full`}
`;
